/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../../app.core.module.js';
import twofaEmailConfig from './2fa.email.config.js';
import twofaEmailRoute from './2fa.email.route.js';
import twofaEmailController from './2fa.email.controller.js';

/**
 * This is the 2fa module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace 2fa Module
 */
angular.module('twofactorEmail', [
  // Shared modules.
  core
])
// Register config.
.config(twofaEmailConfig)
// Register route.
.config(twofaEmailRoute)
// Register controller.
.controller('twofaEmailController', twofaEmailController);


export default 'twofactorEmail';


// WEBPACK FOOTER //
// ./src/login/2fa/email/2fa.email.module.js